import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
  }, [isOpen]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Studio', path: '/studio' },
    { name: 'Contact', path: '/contact' },
  ];

  const getNavBg = () => {
    if (isOpen) return 'bg-brand-ivory';
    if (scrolled) return 'bg-white/95 backdrop-blur-md shadow-sm py-4';
    return 'bg-transparent py-8';
  };

  return (
    <>
      <nav className={`fixed top-0 w-full z-[120] transition-all duration-500 ${getNavBg()}`}>
        <div className="container mx-auto px-6 flex justify-between items-center">
          <Link to="/" className="text-xl font-heading font-extrabold tracking-widest uppercase text-brand-charcoal z-[130]" onClick={() => setIsOpen(false)}>
            LB <span className="text-brand-orange">.</span> BH
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                className={`text-[10px] font-bold tracking-[0.3em] uppercase transition-colors ${location.pathname === link.path ? 'text-brand-orange' : 'text-brand-charcoal hover:text-brand-orange'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking" className="bg-brand-orange text-white px-8 py-3 rounded-full text-[10px] font-bold tracking-[0.3em] uppercase hover:bg-brand-teal transition-all shadow-lg shadow-brand-orange/20">
              Book Now
            </Link>
          </div>

          <button className="md:hidden z-[130] p-3 bg-brand-ivory rounded-full shadow-md border border-brand-charcoal/5" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl text-brand-charcoal" />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} 
            className="fixed inset-0 bg-brand-ivory z-[110] flex flex-col items-center justify-center"
          >
            <div className="flex flex-col items-center gap-8">
              {navLinks.map((link, i) => (
                <motion.div key={link.name} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 + 0.2 }}>
                  <Link to={link.path} onClick={() => setIsOpen(false)} className="text-4xl font-serif italic text-brand-charcoal hover:text-brand-orange">
                    {link.name}
                  </Link>
                </motion.div>
              ))}
              <Link to="/booking" onClick={() => setIsOpen(false)} className="mt-8 bg-brand-orange text-white px-12 py-4 rounded-full text-sm font-bold tracking-widest uppercase shadow-xl">
                Book Session
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;